import { IntegrationsMarketplaceGridAvailableWebComponent } from './component/IntegrationsMarketplaceGridAvailableWebComponent';
import { WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_AVAILABLE } from '../../webcomponents.constants';

export { IntegrationsMarketplaceGridAvailableWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_AVAILABLE,
  IntegrationsMarketplaceGridAvailableWebComponent
);
